import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, TextInput, StyleSheet } from 'react-native';
import { Button, IconButton } from 'react-native-paper';
import Colors from '../../resources/Colors';
import { head } from 'lodash';

const ChatActionArea = (props: any) => {
  const [activeTab, setActiveTab] = useState('chat');
  const [notes, setNotes] = useState('');

  useEffect(() => {
    setNotes(props.notes? props.notes: "")
  },[props.notes])

  return (
    <View style={styles.container}>
      {/* HEADER DE TABS - Compacto y Minimalista */}
      <View style={styles.tabBar}>
        <TouchableOpacity
          onPress={() => setActiveTab('chat')}
          style={[styles.tabItem, activeTab === 'chat' && styles.activeTabItem]}
        >
          <View style={styles.tabContent}>
            <IconButton icon="send" size={18} iconColor={activeTab === 'chat' ? '#6200ee' : '#757575'} />
            <Text style={[styles.tabLabel, activeTab === 'chat' && styles.activeTabLabel]}>
              Enviar Mensaje
            </Text>
          </View>
        </TouchableOpacity>

        <TouchableOpacity
          onPress={() => setActiveTab('notes')}
          style={[styles.tabItem, activeTab === 'notes' && styles.activeTabItem]}
        >
          <View style={styles.tabContent}>
            <IconButton icon="notebook-edit" size={18} iconColor={activeTab === 'notes' ? '#6200ee' : '#757575'} />
            <Text style={[styles.tabLabel, activeTab === 'notes' && styles.activeTabLabel]}>
              Nota interna
            </Text>
          </View>
        </TouchableOpacity>
      </View>

      {/* CONTENIDO DE LAS PESTAÑAS */}
      <View style={styles.contentArea}>
        {activeTab === 'chat' ? (
          <View style={styles.inputWrapper}>
            {props.children}
          </View>
        ) : (
          <View style={styles.inputWrapper}>
            <TextInput
              placeholder="Escribe una nota privada (solo tú y tu equipo podrán verla)..."
              multiline
              value={notes}
              onChangeText={setNotes}
              style={styles.noteInput}
            />
            <View style={styles.buttonRow}>
              <Button
                mode="contained"
                onPress={() => {
                  props.onSaveNote(notes)
                }}
              >
                Guardar en Bitácora
              </Button>
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    borderTopWidth: 1,
    borderTopColor: '#e0e0e0',
  },
  tabBar: {
    flexDirection: 'row',
    height: 45, // Aquí controlas que no se vean "cuadros gigantes"
    backgroundColor: '#f8f9fa',
  },
  tabItem: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomColor: 'transparent',
  },
  activeTabItem: {
    backgroundColor: '#fff',
    borderBottomColor: '#6200ee',
  },
  tabContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tabLabel: {
    fontSize: 13,
    fontWeight: '500',
    color: '#757575',
    marginLeft: -8, // Ajuste para pegar el texto al icono de Paper
  },
  activeTabLabel: {
    color: '#6200ee',
    fontWeight: 'bold',
  },
  contentArea: {
    flex: 1,
    paddingTop: 10,
  },
  inputWrapper: {
    flex: 1,
  },
  chatInput: {
    flex: 1,
    fontSize: 15,
    outlineStyle: 'none', // Quita el borde azul de los navegadores
    textAlignVertical: 'top',
  },
  noteInput: {
    fontSize: 15,
    padding: 10,
    backgroundColor: Colors.inputTextBackground, // Fondo tipo post-it
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.primary,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 8,
    gap: 10,
  }
});

export default ChatActionArea;